(function () {
    const searchbar = document.querySelector("#search");
    const input = document.querySelector("#search-query");

    if (searchbar && input) {
        input.addEventListener("focus", () => {
            searchbar.classList.add("search--focused");
        });
        input.addEventListener("blur", () => {
            searchbar.classList.remove("search--focused");
        });
    }
})();
